<template>
  <f7-page
    class="main-data-order-no-order"
    :page-content="false"
  >
    <template #fixed>
      <Navbar
        :nav-title="!editable ? 'Nueva Expedición' : 'Editar Expedición'"
        :back-btn-enable="true"
        :back-callback="BackToMain"
        :style="appTheme"
      />
    </template>

    <f7-page-content>
      <f7-block class="content-form-data-order">
        <div>
          <UCSearchEntityERP
            ref="UCLoadingDockComponent"
            :title="$t('searchEntity.loadingDock.title.loadingDock')"
            :placeholder="$t('searchEntity.loadingDock.placeholder.searchLoadingDock')"
            :search-text="$t('searchEntity.loadingDock.searchText')"
            :search-cancellation-text="$t('searchEntity.loadingDock.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.loadingDock.searchNotFoundText')"
            :default-value="muelleCarga"
            :end-point-for-code-search="GetDockByCode"
            :end-point-for-list="GetDock"
            :property-entity-shown-input="Array('Codigo', 'Nombre')"
            :property-entity-shown-list-title="Array('Codigo')"
            :property-entity-shown-list-subtitle="Array('Nombre')"
            :min-text-search="0"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            @selection="EventDockSelected"
          />
        </div>
        <div class="container-filters__warehouse">
          <UCSearchEntityERP
            :title="$t('common.carrier')"
            :placeholder="$t('searchEntity.carrier.placeholder.searchByCarrier')"
            :search-text="$t('searchEntity.carrier.searchText')"
            :search-cancellation-text="$t('searchEntity.carrier.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.carrier.searchNotFoundText')"
            :end-point-for-code-search="GetCarrierByCode"
            :end-point-for-list="GetCarrier"
            :property-entity-shown-input="Array('Sujeto.NombreSujeto', 'Codigo')"
            :property-entity-shown-list-title="Array('Sujeto.NombreSujeto')"
            :property-entity-shown-list-subtitle="Array('Codigo')"
            :default-value="carrier"
            :min-text-search="0"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            @selection="EventCarrierSelected"
          />
        </div>
        <div>
          <UCSearchEntityERP
            ref="UCmatricula2Component"
            :title="$t('common.registration')"
            :placeholder="$t('searchEntity.plate.placeholder.searchByPlate')"
            :search-text="$t('searchEntity.plate.searchText')"
            :search-cancellation-text="$t('searchEntity.plate.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.plate.searchNotFoundText')"
            :end-point-for-code-search="GetPlatesByCode"
            :end-point-for-list="GetPlates"
            :property-entity-shown-input="Array('Matricula', 'Descripcion')"
            :property-entity-shown-list-title="Array('Matricula')"
            :property-entity-shown-list-subtitle="Array('Descripcion')"
            :min-text-search="0"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            @selection="EventLicenseSelected"
          />
        </div>
        <div>
          <div class="margin-left-half texto margin-top-half">
            {{ $t('commercialization.common.truckTemperature') }}
          </div>

          <f7-list no-hairlines-md>
            <f7-list-input
              class="input-normal"
              type="number"
              step=".001"
              floating-label
              clear-button
              :value="temperatura"
              @input="temperatura = $event.target.value"
            />
          </f7-list>
        </div>
        <div class="margin-top-half row">
          <div class="col">
            <div class="margin-left-half texto">
              {{ $t('common.driver') }}
            </div>

            <f7-list no-hairlines-md>
              <f7-list-input
                class="input-normal"
                type="text"
                floating-label
                size="20"
                clear-button
                :value="driver"
                @input="driver = $event.target.value"
              />
            </f7-list>
          </div>
          <div class="col">
            <div class="margin-left-half texto">
              {{ $t('common.dni') }}
            </div>

            <f7-list no-hairlines-md>
              <f7-list-input
                class="input-normal"
                type="text"
                floating-label
                clear-button
                :value="dni"
                @input="dni = $event.target.value"
              />
            </f7-list>
          </div>
        </div>
        <div class="margin-top-half row">
          <div class="col">
            <div class="margin-left-half texto">
              {{ $t('commercialization.common.trailerLicensePlate') }}
            </div>

            <f7-list no-hairlines-md>
              <f7-list-input
                class="input-normal"
                type="text"
                floating-label
                clear-button
                @input="matricula2 = $event.target.value"
              />
            </f7-list>
          </div>
          <div class="col">
            <div class="margin-left-half texto">
              {{ $t('commercialization.common.expectedArrivalDate') }}
            </div>

            <f7-list no-hairlines-md>
              <f7-list-input
                class="input-normal input-fecha"
                type="datepicker"
                floating-label
                :value="[new Date()]"
                @input="dateOfExpedition = $event.target.value"
              />
            </f7-list>
          </div>
        </div>
        <div class="margin-top-half">
          <div class="margin-left-half texto">
            {{ $t('common.observations') }}
          </div>
          <textarea
            class="input-text"
            name="textarea"
            rows="8"
            cols="50"
            :value="observations"
            @input="observations = $event.target.value"
          />
        </div>
      </f7-block>

      <div class="container-btn">
        <f7-button
          v-if="!editable"
          class="btn-create-expedition"
          fill
          @click="PressCreateNewExpedition"
        >
          {{ $t('commercialization.common.createExpedition') }}
        </f7-button>
        <f7-button
          v-else
          class="btn-create-expedition"
          fill
          @click="PressCreateNewExpedition"
        >
          {{ $t('commercialization.common.editExpedition') }}
        </f7-button>
      </div>
    </f7-page-content>
  </f7-page>
</template>

<script>
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import Navbar from '@/components/TheNavbar.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import APIErp from '@/js/services/APIErp';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'FrmExpeditionDocumentNoSalesCompleteData',

  components: {
    Navbar,
    UCSearchEntityERP,
  },

  props: {
    expeditionDocument: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    returnToNoSalesOrder: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      carrier: null, // transportista seleccionado
      driver: null, // Conductor seleccionado
      dni: null, // dni conductor
      temperatura: null,
      matricula2: null, // matricula camion
      dateOfExpedition: null, // fecha de la expediciona
      observations: null, // observaciones
      expeditionDocumentSelected: null, // documento de expedicion que tenemos seleccionado // TODO MARINA : Añadir el documento de ex
      matricula: null,
      muelleCarga: null,
    };
  },
  computed: {

    appTheme() {
      return {
        '--f7-navbar-bg-color': '#556080',
      };
    },
  },
  watch: {
    // whenever question changes
    expeditionDocument(newExpedition) {
      this.expeditionDocumentSelected = newExpedition;
    },
  },
  created() {

  },
  mounted() {
    this.StartComponent();
  },
  // TODO MARINA: Añadir la llamada de LOG en las llamadas de los métodos que nos viene bien para luego depurar errores.
  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.dateOfExpedition = new Date();
      this.expeditionDocumentSelected = this.expeditionDocument;

      this.muelleCarga = this.expeditionDocumentSelected.MuelleCarga;
      if (this.muelleCarga) {
        this.$refs.UCLoadingDockComponent.SelectEntity(this.muelleCarga, true);
      }
      this.carrier = this.expeditionDocumentSelected.Transportista;
      this.matricula = this.expeditionDocumentSelected.Matricula;
      if (this.matricula) {
        this.$refs.UCmatricula2Component.SetInputValue(this.matricula);
      }
      this.driver = this.expeditionDocumentSelected.Conductor;
      this.matricula2 = this.expeditionDocumentSelected.Matricula;
      this.observations = this.expeditionDocumentSelected.Observaciones;
      this.dni = this.expeditionDocumentSelected.Dni;
      this.temperatura = this.expeditionDocumentSelected.Temperatura;
    },
    async PressCreateNewExpedition() {
      Log(this, this.PressCreateNewExpedition.name);
      /* if (this.muelleCarga === null) {
        faltanDatos = true;
      }
      if (this.carrier === null) {
        faltanDatos = true;
      }
      if (this.matricula === null) {
        if (!this.CheckNewCarLicense()) { faltanDatos = true; } else { return; }
      }
      if (this.driver === null) {
        faltanDatos = true;
      }
      if (this.dni === null) {
        faltanDatos = true;
      }
      if (this.matricula2 === null) {
        faltanDatos = true;
      }
      if (this.dateOfExpedition === null) {
        faltanDatos = true;
      }
       if (this.observations === null) {
        faltanDatos = true;
      } */

      /*  if (faltanDatos) {
        HiNotification.Alert('Complete todos los datos para continuar', 'Aviso');
      } else {} */
      if (this.matricula === null) {
        await this.CheckNewCarLicense();
      }

      if (this.editable) {
        this.expeditionDocumentSelected.MuelleCarga = this.muelleCarga;
        this.expeditionDocumentSelected.Transportista = this.carrier;
        this.expeditionDocumentSelected.Matricula = this.matricula;
        this.expeditionDocumentSelected.Conductor = this.driver;
        this.expeditionDocumentSelected.Dni = this.dni;
        this.expeditionDocumentSelected.Temperatura = this.temperatura;
        this.expeditionDocumentSelected.FechaLlegada = this.dateOfExpedition;
        this.expeditionDocumentSelected.Observaciones = this.observations;
        this.expeditionDocumentSelected.EstadoOrdenCarga = 0;
        this.expeditionDocumentSelected.FechaSalida = HiDateTimeSupport.FormatDateTime(Date.now(), 'YYYY-MM-DD HH:mm:ss');
        this.expeditionDocumentSelected.Matricula2 = this.matricula2;
      } else {
        this.expeditionDocumentSelected.Id = 0;
        this.expeditionDocumentSelected.MuelleCarga = this.muelleCarga;
        this.expeditionDocumentSelected.Transportista = this.carrier;
        this.expeditionDocumentSelected.Matricula = this.matricula;
        this.expeditionDocumentSelected.Conductor = this.driver;
        this.expeditionDocumentSelected.Dni = this.dni;
        this.expeditionDocumentSelected.Temperatura = this.temperatura;
        this.expeditionDocumentSelected.FechaLlegada = this.dateOfExpedition;
        this.expeditionDocumentSelected.Observaciones = this.observations;
        this.expeditionDocumentSelected.EstadoOrdenCarga = 0;
        this.expeditionDocumentSelected.FechaSalida = HiDateTimeSupport.FormatDateTime(Date.now(), 'YYYY-MM-DD HH:mm:ss');
        this.expeditionDocumentSelected.Matricula2 = this.matricula2;
      }
      // Guardado de expedición
      const resultSave = await this.SaveExpedition(this.expeditionDocumentSelected);
      if (resultSave == null) { return; }
      this.expeditionDocumentSelected = resultSave;
      f7.views.main.router.navigate('/commercialisation/expedition/noSalesOrder/frmExpeditionDocumentNoSales', {
        props: {
          expeditionDocument: this.expeditionDocumentSelected,
          reload: true,
        },
      });

      // f7.views.main.router.clearPreviousHistory(true);
    },
    async BackToMain() {
      Log(this, this.BackToMain.name);

      if (this.returnToNoSalesOrder) {
        f7.views.main.router.back();
        return;
      }

      if (!this.editable) {
        f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionEditLines', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            expeditionDocument: this.expeditionDocumentSelected,
            clearDescgloses: true,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      } else {
        f7.views.main.router.back();
      }
    },
    EventCarrierSelected(value) {
      Log(this, this.EventCarrierSelected.name);
      this.carrier = value;
    },
    async CheckNewCarLicense() {
      Log(this, this.CheckNewCarLicense.name);
      const inputValue = this.$refs.UCmatricula2Component.GetInputValue();
      if (inputValue === '') { return false; }
      this.matricula = inputValue;

      /* this.$refs.UCConfirmation.create('Matricula Camión',
        `Esta matricula no esta dada de alta. ¿Quieres continuar con la matricula ${inputValue} que has introducido?`,
        this.NewCarLicense);
      this.$refs.UCConfirmation.show(); */
      return true;
    },
    EventLicenseSelected(objLicense) {
      Log(this, this.EventLicenseSelected.name);
      if (objLicense != null) {
        this.matricula = objLicense.Matricula;
      } else {
        this.matricula = objLicense;
      }
    },
    GetPlates() {
      Log(this, this.GetPlates.name);
      return APIErp.callGetVehicle();
    },
    GetPlatesByCode() {
      Log(this, this.GetPlatesByCode.name);
      return APIErp.callGetVehicle();
    },

    /* Transportista */
    GetCarrier() {
      Log(this, this.GetCarrier.name);
      return APIErp.callGetCarrier();
    },
    GetCarrierByCode(params) {
      Log(this, this.GetCarrierByCode.name);
      return APIErp.callGetCarrier(params);
    },
    async SaveExpedition(objExpedition) {
      HiDialog.Preloader(true, 'Guardando orden de carga', false);
      try {
        const result = await APIErp.callSaveExpeditionNoSales(objExpedition);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error.response.data.Mensaje, 'Orden de carga no creada');
        return null;
      }
    },
    /* Muelle */
    EventDockSelected(value) {
      Log(this, this.EventDockSelected.name);
      this.muelleCarga = value;
    },
    GetDock() {
      Log(this, this.GetDock.name);
      return APIErp.callGetDock();
    },
    GetDockByCode(params) {
      Log(this, this.GetDockByCode.name);
      return APIErp.GetDockByCode(params);
    },
  },
};
</script>

<style lang="scss">
.main-data-order-no-order {
  --search-title-color: var(--f7-block-title-text-color);
  --search-title-font-size: var(--f7-block-title-font-size);
  --f7-input-height: 36px;
  --f7-input-bg-color: transparent;

  .page-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .content-form-data-order {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .list {
    --f7-list-bg-color: transparent;

    ul {
      li {
        --f7-input-font-size: 14px;
        --f7-input-text-color: var(--his-steel-blue);
        background: #fff;
        height: 36px;
        width: 100%;
        margin-top: 5px;
        border: 1px solid var(--his-silver);
        border-radius: 8px;
      }
    }

    ul::before,
    ul::after {
      height: 0;
    }
  }

  textarea {
    border: 1px solid var(--his-silver);
    border-radius: 8px;
  }

  .input-fecha {
    width: 20vh;
  }

  .input-text {
    width: 100%;
    background: #fff;
    margin-top: 1vh;
    padding: 6px;
  }

  .texto {
    line-height: 1;
    color: var(--f7-block-title-text-color);
    font-size: var(--f7-block-title-font-size);
  }

  .content-searcher-titulo {
    color: var(--f7-block-title-text-color);
    font-size: var(--f7-block-title-font-size);
  }

  .container-btn {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-bottom: calc(8px + var(--information-bar-height));

    .btn-create-expedition {
      width: 100%;
      margin-left: 3vh;
      margin-right: 3vh;
      background: var(--his-steel-blue);
    }
  }
}
</style>
